













































import Vue, { PropType } from 'vue'
import { EventItem } from '../../../base/store/state.interface'
import MessagesWidgetBaseItem from './MessagesWidgetBaseItem.vue'
import MessagesWidgetEventItemMixin from './MessagesWidgetEventItemMixin'
import MessagesWidgetMixins from './MessagesWidgetMixins'

export default Vue.extend({
  mixins: [
    MessagesWidgetMixins,
    MessagesWidgetEventItemMixin
  ],
  components: {
    MessagesWidgetBaseItem
  },
  props: {
    item: {
      type: Object as PropType<EventItem>,
      required: true
    },
    index: {
      type: String as PropType<string>,
      required: true
    }
  }
})
